import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { format } from "date-fns";
//import ReactToPrint from "react-to-print";
import Licencia from "../components/content/componente.js";
import CertificadoNM from "../components/content/certificado_nm.jsx";
import Certificado from "../components/content/certificados/certificado_producto.js";
import CertificadoP from "../components/content/certificados/certificado.js";
import AvalCE from "../components/content/casos_especiales/aval.js";
import Swal from "sweetalert2";

class LicensePrint extends React.Component {
  constructor(props) {
    super(props);

    this.handleLicensePage = this.handleLicensePage.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleChangeStatusEst = this.handleChangeStatusEst.bind(this);
    this.handleChangeStatusPro = this.handleChangeStatusPro.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseModalCE = this.handleCloseModalCE.bind(this);
    this.handleLicenciaEstablecimiento =
      this.handleLicenciaEstablecimiento.bind(this);
    this.handleClick_e = this.handleClick_e.bind(this);
    this.handleImprimir = this.handleImprimir.bind(this);
    this.handleLicenciaProducto = this.handleLicenciaProducto.bind(this);
    this.handleClick_p = this.handleClick_p.bind(this);
    this.handleConstanciasPage = this.handleConstanciasPage.bind(this);
    this.handleClick_c = this.handleClick_c.bind(this);
    this.handleCertificadoPage = this.handleCertificadoPage.bind(this);
    this.handleClick_cer = this.handleClick_cer.bind(this);

    this.handleNotifyRegente = this.handleNotifyRegente.bind(this);
    this.handleNotifyConstancia = this.handleNotifyConstancia.bind(this);
    this.handleNotifyProducto = this.handleNotifyProducto.bind(this);
    this.handleNotifyEstablecimiento =
      this.handleNotifyEstablecimiento.bind(this);
    this.handleNotifyCertificado = this.handleNotifyCertificado.bind(this); //CAMBIAR A CERTIFICADO

    this.handleImprimirProducto = this.handleImprimirProducto.bind(this);
    this.handleImprimirCertificado = this.handleImprimirCertificado.bind(this);

    this.handleClick_r = this.handleClick_r.bind(this);
    this.handleNotifyRefrenda = this.handleNotifyRefrenda.bind(this);

    this.handleClick_pre = this.handleClick_pre.bind(this);
    this.handleClick_ce = this.handleClick_ce.bind(this);
    this.handleNotifyPre = this.handleNotifyPre.bind(this);
    this.handleClick_nm = this.handleClick_nm.bind(this);
    this.handleNotifyEstablecimientoNM = this.handleNotifyEstablecimientoNM.bind(this);
    this.setCasosEspecialesPage = this.setCasosEspecialesPage.bind(this);
    this.handleImprimirNM = this.handleImprimirNM.bind(this);

    this.state = {
      modalLicencia: false,
      modalLicencia_e: false,
      modalLicencia_p: false,
      modalLicencia_cer: false,
      modalCertificadoNM: false,
      working: true,
      nivelUsuario: localStorage.nivel_actual,
      tramiteCombo: Api.loadCatalogue("cat_accion"),
      tipoRegenteCombo: Api.loadCatalogue("cat_tipo_regente"),
      estatusCombo: Api.loadCatalogue("cat_estatus_licencia"),
      tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
      actividadCombo: Api.loadCatalogue("cat_actividad"),
      estatus_productoCombo: Api.loadCatalogue("cat_estatus_producto"),
      tramitePro: Api.loadCatalogue("cat_tramite"),
      constanciaTipoCombo: Api.loadCatalogue("cat_constancia_tipo"),
      validezCombo: Api.loadCatalogue("cat_validez"),
      cat_tipo_importacion: Api.loadCatalogue("cat_tipo_importacion"),
      certificadoCombo: Api.loadCatalogue("cat_tipo_certificado"),
      comboNotaMargianl: Api.loadCatalogue("cat_anotacion_marginal"),
      licencias: [],
      licencias_e: [],
      licencias_p: [],
      certificados: [],
      casos_especiales: [],
      licencias_nm:[],
      licencia: {
        licencia_id: "",
        nombre_regente: "",
        folio: "",
        fecha_vencimiento: "",
        lugar_emision: "",
        guid: "",
        texto: "",
        tramite: "",
        codigo_regencia: "",
        codigo_ipsa: "",
        profesion: "",
        firma: "",
      },
      caso_especial: {
        id: "",
        tipo_importacion_nombre: "",
        tipo_producto_importacion: "",
        listado: [],
        nombre_solicitante: "",
        fabricante_razon_social: "",
        importador_razon_social: "",
        pais_procedencia_nombre: "",
        pais_origen_nombre: "",
        guia_area: "",
        no_factura: "",
        autorizador_por: "",
        folio: "",
        fines_texto: "",
        importacion_texto: "",
        estimado: "",
        fecha_aprueba: "",
        hora: "",
        qr: "",
      },
      licencia_e: {},
      certificado_p: {},
      certificado_s: {},
      certificado_nm: {},
      activo: [],
      excipiente: [],
      dosis: [],
      descarte: [],
      componente: [],
      especie: [],
      ingrediente: [],
      analisis: [],
      com_biologica: [],
      com_quimica: [],
      date: format(new Date(), "dd/MM/yyyy"), //new Date().toLocaleDateString(),
      constancias: [],
      toggle: false,
      paginaActual: 0,
      paginas: 0,
      registros: 0,
      paginaActual_e: 0,
      paginas_e: 0,
      registros_e: 0,
      paginaActual_p: 0,
      paginas_p: 0,
      registros_p: 0,
      paginaActual_c: 0,
      paginas_c: 0,
      registros_c: 0,
      paginaActual_cer: 0,
      paginaActual_ce: 0,
      modalCasoEspecial: false,
      paginas_cer: 0,
      paginas_ce: 0,
      registros_cer: 0,
      paginaActual_nm: 0,
      paginas_nm: 0,
      registros_nm: 0,
      previa: false,
      previa_rul: "",
      detalle_producto_id: "",
      activeTab: "1",
      collapse: [
        { id: 1, collapse: true },
        { id: 2, collapse: false },
        { id: 3, collapse: false },
        { id: 4, collapse: false },
      ],
      //busquedas
      buscar_reg: {},
      buscar_est: {},
      buscar_pro: {},
      buscar_con: {},
      buscar_certificado: {},
      buscar_cer: {},
      buscarNotaMarginal:{},
      solicitud_cer: {
        id: "",
        folio_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        estatus: "",
        estatus_tramite_id: "",
        tipo_certificado_id: false,
      },
      certificado: {
        id: "",
        forma_farmaceutica: "",
        forma_farmaceutica_id: "",
        folio: "",
        medida_tiempo: "",
        medida_tiepo_id: "",
        nombre_comercial: "",
        pais: "",
        pais_id: "",
        precauciones_generales: "",
        uso: "",
        //metemos las listas que pudieramos necesitar para el certificado
        lista_composiciones_biologicas: [],
        lista_composiciones_quimicas: [],
        lista_analisis: [],
        lista_ingredientes: [],
        lista_principios_activos: [],
        lista_excipiente: [],
        fabricante: [],
        titular: [],
        lista_especie_dosis: [],
        lista_especie: [],
        lista_empaque: [],
        lista_presentaciones: [],
        lista_descarte: [],
        representantes_legales: [],
        regentes: [],
      },
      precertificados: [],
      paginaActual_pre: 0,
      paginas_pre: 0,
      registros_pre: 0,
      registros_ce: 0,
      buscarPrecertificado: {},
      buscarCasoEspecial: {},
      cat_tipo_precertificado: Api.loadCatalogue("cat_tipo_precertificado"),
      texto_reposicion: false,
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({
      collapse: newArray,
    });
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setLicensesPage(1);
    this.setLicensesEstablecimientoPage(1);
    this.setLicensesProductoPage(1);
    this.setConstanciasPage(1);
    this.setCertificadoPage(1);
    this.setPrecertificadosPage(1);
    this.setCasosEspecialesPage(1);
    this.setLicensesEstablecimientoNMPage(1);

    /******* BUSCADORES *********/
    let f_busqueda_r = Api.form({
      target: "#busqueda_r",
      nombre: "busqueda_Regente",
      elementClass: "form-control",
      onChange: (me, data, serial) => {},
      elements: [
        {
          input: {
            type: "text",
            name: "folio_licencia",
            label: "Folio",
            placeHolder: "Ingresa el folio de la licencia",
            cols: 6,
            onChange: (me) => {},
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Nombre del regente",
            placeHolder: "Nombre del regente",
            cols: 6,
          },
        },
        {
          select: {
            type: "text",
            name: "accion_id",
            label: "Tipo trámite",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tipo de trámite</option>`;
              this.state.tramiteCombo.forEach((s) => {
                if (s.id === "1" || s.id === "2" || s.id === "3002") {
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          select: {
            type: "text",
            name: "estatus_id",
            label: "Estado",
            placeHolder: "Estado",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el estatus</option>`;
              this.state.estatusCombo.forEach((s) => {
                //if (s.id < 4 || s.id == 5) {
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                //}
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha emisión desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha emisión hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo",
            label: "Tipo regente",
            cols: 5,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tipo de regente</option>`;
              this.state.tipoRegenteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "text",
            name: "nombre_personal",
            label: "Nombre del personal operativo",
            placeHolder: "Nombre del personal que activo/desacivo la licencia",
            cols: 5,
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar_reg: f_busqueda_r.data() });
              this.setLicensesPage(1);
            },
          },
        },
      ],
    });

    let f_busqueda_e = Api.form({
      target: "#busqueda_e",
      nombre: "busqueda_establecimiento",
      elementClass: "form-control",
      onChange: (me, data, serial) => {},
      elements: [
        {
          input: {
            type: "text",
            name: "folio_licencia",
            label: "Folio",
            placeHolder: "Ingresa el folio de la licencia",
            cols: 3,
            onChange: (me) => {},
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Razón social",
            placeHolder: "Nombre del establecimiento",
            cols: 3,
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus_id",
            label: "Estado",
            placeHolder: "Estado",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el estatus</option>`;
              this.state.estatusCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            type: "text",
            name: "tipo",
            label: "Tipo establecimiento",
            cols: 9,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tipo de establecimiento</option>`;
              this.state.tipo_establecimiento.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            type: "text",
            name: "actividad_id",
            label: "Actividad",
            cols: 10,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione la actividad del establecimiento</option>`;
              this.state.actividadCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        } /*,{
            input: {
                type: "text",
                name: "nombre_personal",
                label: "Nombre del personal operativo",
                placeHolder: "Nombre del personal que activo/desacivo la licencia",
                cols: 5,
            }
          }*/,
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar_est: f_busqueda_e.data() });
              this.setLicensesEstablecimientoPage(1);
            },
          },
        },
      ],
    });

    let f_busqueda_p = Api.form({
      target: "#busqueda_p",
      nombre: "busqueda_producto",
      elementClass: "form-control",
      onChange: (me, data, serial) => {},
      elements: [
        {
          input: {
            type: "text",
            name: "no_registro",
            label: "Número de registro",
            pattern: "[0-9]{0,7}",
            placeHolder: "No. registro",
            cols: 4,
            onChange: (me) => {},
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Nombre",
            placeHolder: "Nombre del producto",
            cols: 4,
          },
        },
        {
          select: {
            type: "text",
            name: "tramite",
            label: "Tramite",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tramite</option>`;
              this.state.tramitePro.forEach((s) => {
                if (s.id === "4" || s.id === "11") {
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
                }
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus_id",
            label: "Estado",
            placeHolder: "Estado",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el estatus</option>`;
              this.state.estatus_productoCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        } /*,{
            input: {
                type: "text",
                name: "nombre_personal",
                label: "Nombre del personal operativo",
                placeHolder: "Nombre del personal que activo/desacivo la licencia",
                cols: 5,
            }
          }*/,
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar_pro: f_busqueda_p.data() });
              this.setLicensesProductoPage(1);
            },
          },
        },
      ],
    });

    let f_busqueda_c = Api.form({
      target: "#busqueda_c",
      nombre: "busqueda_producto",
      elementClass: "form-control",
      onChange: (me, data, serial) => {},
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Folio",
            cols: 5,
            onChange: (me) => {},
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_constancia",
            label: "Tio de constancia",
            cols: 7,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tipo de constancia</option>`;
              this.state.constanciaTipoCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "validez",
            label: "Validez",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione la validez (en días)</option>`;
              this.state.validezCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        } /*{
            select: {
                type: "text",
                name: "estatus_id",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione el estatus</option>`;
                    this.state.estatus_productoCombo.forEach(s=>{
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    })
                })
            }
          }*/,
        ,
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar_con: f_busqueda_c.data() });
              this.setConstanciasPage(1);
            },
          },
        },
      ],
    });

    let f_busqueda_certificado = Api.form({
      target: "#busqueda_certificado",
      nombre: "busqueda_certificado",
      elementClass: "form-control",
      onChange: (me, data, serial) => {},
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Folio",
            cols: 6,
            onChange: (me) => {},
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_certificado",
            label: "Tio de certificado",
            cols: 6,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione el tipo de certificado</option>`;
              this.state.certificadoCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "text",
            name: "nombre_comercial",
            label: "Nombre comercial",
            placeHolder: "Nombre comercial",
            cols: 4,
            onChange: (me) => {},
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        } /* {
            select: {
                type: "text",
                name: "estatus_id",
                label: "Estado",
                placeHolder: "Estado",
                cols: 4,
                render:(me=>{
                  me.innerHTML=`<option value="">Seleccione el estatus</option>`;
                    this.state.estatus_productoCombo.forEach(s=>{
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    })
                })
            }
          }, */,
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({
                buscar_certificado: f_busqueda_certificado.data(),
              });
              this.setCertificadoPage(1);
            },
          },
        },
      ],
    });

    let bPrecertificado = Api.form({
      target: "#f_busqueda_pre",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio precertificado",
            placeHolder: "Folio precertificado",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "num_factura",
            label: "Número de factura",
            placeHolder: "Número de factura",
            cols: 4,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_precertificado",
            label: "Tipo de precertificado",
            placeHolder: "Tipo de precertificado",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_precertificado.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 4,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 4,
            value: "",
          },
        },
        /* {
          select: {
            cols: 2,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        }, */
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 4,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarPrecertificado: bPrecertificado.data() });
              this.setPrecertificadosPage(1);
            },
          },
        },
      ],
    });

    /** BUSCADOR PARA CASOS ESPECIALES */
    let buscadorCE = {
      target: "#buscadorCE",
      nombre: "buscadorCE",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "folio",
            type: "text",
            label: "Folio",
            placeHolder: "Ingrse folio",
          },
        },
        {
          select: {
            cols: 4,
            name: "tipo_importacion",
            type: "text",
            label: "Tipo importación",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_importacion
                .filter((item) => ["1", "7", "8"].includes(item.id))
                .forEach((ti) => {
                  me.innerHTML += `<option value="${ti.id}">${ti.descripcion}</option>`;
                });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha_emision",
            type: "date",
            label: "Fecha emisión",
          },
        },

        {
          input: {
            cols: 5,
            name: "establecimiento_importador",
            type: "text",
            label: "Establecimiento importador",
            placeHolder: "Ingrese establecimiento importador",
          },
        },

        {
          input: {
            cols: 5,
            name: "establecimiento_fabricante",
            type: "text",
            label: "Establecimiento fabricante",
            placeHolder: "Ingrese establecimiento fabricante",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamov",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCasoEspecial: buscadorCE.data() });
              this.setCasosEspecialesPage(1);
            },
          },
        },
      ],
    };

    buscadorCE = Api.form(buscadorCE);
    /** TERMINA BUSCADOR PARA CASOS ESPECIALES */
   
    let buscadorNM = {
      target: "#buscadorNM",
      nombre: "buscadorNM",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          input: {
            cols: 2,
            name: "razon_social",
            type: "text",
            label: "Razón social",
          },
        },
        {
          select: {
            cols: 4,
            name: "anotacion_id",
            label: "Tipo de anotación marginal",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.comboNotaMargianl.forEach((nm) => {
                me.innerHTML += `<option value="${nm.id}">${nm.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 2,
            name: "fecha_emision",
            type: "date",
            label: "Fecha emisión",
          },
        },
        {
          button: {
            cols: 2,
            name: "btnBucadorMN",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarNotaMarginal: buscadorNM.data() });
              this.setLicensesEstablecimientoNMPage(1);
            },
          },
        },
      ],
    };

    buscadorNM = Api.form(buscadorNM);
  }

  setLicensesPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar_reg;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getLicenseRegentAppReadyForPrint?page=" + page + src).then(
      (r) => {
        this.setState({
          licencias: r.data,
          paginas: r.last_page,
          registros: r.total,
          paginaActual: r.current_page,
          workingGrid: false,
        });
      }
    );
  }

  setLicensesEstablecimientoPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar_est;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getLicenseEstablecimientoAppReadyForPrint?page=" + page + src
    ).then((e) => {
      this.setState({
        licencias_e: e.data,
        paginas_e: e.last_page,
        registros_e: e.total,
        paginaActual_e: e.current_page,
        workingGrid: false,
      });
    });
  }

  setLicensesProductoPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar_pro;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getProductosCertificados?page=" + page + src).then((p) => {
      this.setState({
        licencias_p: p.data,
        paginas_p: p.last_page,
        registros_p: p.total,
        paginaActual_p: p.current_page,
        workingGrid: false,
      });
    });
  }

  setConstanciasPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar_con;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getConstanciasImprimir?page=" + page + src).then((m) => {
      this.setState({
        constancias: m.data,
        paginas_c: m.last_page,
        registros_c: m.total,
        paginaActual_c: m.current_page,
        workingGrid: false,
      });
    });
  }

  setCertificadoPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscar_certificado;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getCertificadosImprimir?page=" + page + src).then((m) => {
      this.setState({
        certificados: m.data,
        paginas_cer: m.last_page,
        registros_cer: m.total,
        paginaActual_cer: m.current_page,
        workingGrid: false,
      });
    });
  }

  setPrecertificadosPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarPrecertificado;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getPrecertificadosImprimir?page=" + page + src).then((m) => {
      this.setState({
        precertificados: m.data,
        paginas_pre: m.last_page,
        registros_pre: m.total,
        paginaActual_pre: m.current_page,
        workingGrid: false,
      });
    });
  }

  setCasosEspecialesPage(page) {
    this.setState({ workingGridCE: true });

    let search = this.state.buscarCasoEspecial;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getCasosEspecialesImprimir?page=" + page + src).then(
      (ce) => {
        this.setState({
          casos_especiales: ce.data,
          paginas_ce: ce.last_page,
          registros_ce: ce.total,
          paginaActual_ce: ce.current_page,
          workingGridCE: false,
        });
      }
    );
  }

  setLicensesEstablecimientoNMPage(page) {
    this.setState({ workingGrid: true });

    let search = this.state.buscarNotaMarginal;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getLicenseEstablecimientoNMAppReadyForPrint?page=" + page + src
    ).then((e) => {
      this.setState({
        licencias_nm: e.data,
        paginas_nm: e.last_page,
        registros_nm: e.total,
        paginaActual_nm: e.current_page,
        workingGrid: false,
      });
    });
  }

  handleClose() {
    this.setState({
      modalLicencia: false,
      modalLicencia_e: false,
      modalLicencia_p: false,
      modalLicencia_cer: false,
      modalCasoEspecial: false,
      modalCertificadoNM: false,
      texto_reposicion: false,
    });
  }

  handleCloseModalCE() {
    this.setState({
      modalCasoEspecial: false,
      caso_especial: {
        id: "",
        tipo_importacion_nombre: "",
        tipo_producto_importacion: "",
        listado: [],
        nombre_solicitante: "",
        fabricante_razon_social: "",
        importador_razon_social: "",
        pais_procedencia_nombre: "",
        pais_origen_nombre: "",
        guia_area: "",
        no_factura: "",
        autorizador_por: "",
        folio: "",
        fines_texto: "",
        importacion_texto: "",
        estimado: "",
        fecha_aprueba: "",
        hora: "",
        qr: "",
      },
    });
  }

  handleLicensePage(e) {
    this.setLicensesPage(e.target.value);
  }

  handleLicenciaEstablecimiento(e) {
    this.setLicensesEstablecimientoPage(e.target.value);
  }

  handleLicenciaProducto(e) {
    this.setLicensesProductoPage(e.target.value);
  }

  handleConstanciasPage(e) {
    this.setConstanciasPage(e.target.value);
  }

  handleCertificadoPage(e) {
    this.setCertificadoPage(e.target.value);
  }

  handlePreCertificadosPage(e) {
    this.setPreCertificadosPage(e.target.value);
  }

  handleLicenciaEstablecimientoNM(e) {
    this.setLicensesEstablecimientoNMPage(e.target.value);
  }

  handleChangeStatus(estatus_id, id) {
    Swal.fire({
      title: "¿Está seguro de está acción?",
      text: "Ingrese el motivo",
      input: "textarea",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);

        Api.fetch(
          "app/updateStatusLicenciaRegente",
          {
            id: id,
            estatus_id: parseInt(estatus_id) === 1 ? 5 : 1,
            observacion: result.value,
          },
          "PUT"
        ).then((r) => {
          // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
          this.setLicensesPage(this.state.paginaActual);
          Api.loading(false);
          //Notificamos sin obstruir el UI, que todo bien.
          //Api.notify(r.message);
          Swal.fire({
            title: "Actualizado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  handleChangeStatusEst(estatus_id, id) {
    Swal.fire({
      title: "¿Está seguro de está acción?",
      text: "Ingrese el motivo",
      input: "textarea",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);

        Api.fetch(
          "app/updateStatusEstablecimiento",
          {
            id,
            estatus_id: parseInt(estatus_id) === 1 ? 5 : 1,
            observacion: result.value,
          },
          "PUT"
        ).then((r) => {
          // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
          this.setLicensesEstablecimientoPage(this.state.paginaActual_e);
          Api.loading(false);
          //Notificamos sin obstruir el UI, que todo bien.
          //Api.notify(r.message);
          Swal.fire({
            title: "Actualizado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  handleChangeStatusPro(estatus_id, id) {
    //si estatus es 1 o 3 se va a 2(suspendido) en caso contrario a 1
    let estatus = estatus_id !== "2" ? 2 : 1;
    Api.fetch(
      "app/updateStatusCertificadoProducto",
      { id, estatus_id: estatus },
      "PUT"
    ).then((r) => {
      // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
      this.setLicensesProductoPage(this.state.paginaActual_p);
      Api.loading(false);
      //Notificamos sin obstruir el UI, que todo bien.
      Api.notify(r.message);
    });
  }

  handleClick(e) {
    let accion_id = e.target.getAttribute("data-accion-id");

    Api.fetch("app/existeReposicionLicenciaRegente", { id: e.target.id, accion_id: accion_id }, "POST").then((r) => {
      if(r){//existe solicitud de reposicion ya aceptada
        Swal.fire({
          title: "¿Cuál licencia quieres ver?",
          showCancelButton: true,
          confirmButtonColor: "#1E90FF",
          confirmButtonText: "Original",
          showLoaderOnConfirm: true,
          reverseButtons: false,
          cancelButtonColor: "#1E90FF",
          cancelButtonText: "Reposición",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: true,
        }).then((result) => {
          if((result.isDismissed && result.dismiss === 'cancel') || result.isConfirmed){
            let reposicion = true;
            if (result.isConfirmed) {//alta o Renovación
              reposicion = false;
            }

            this.setState({
              modalLicencia: true,
              working: true,
              texto_reposicion: reposicion,
            });

            Api.fetch("app/getLicenseRegent", { id: e.target.id, accion_id: accion_id }, "POST").then((r) => {
              this.setState({
                licencia: r,
                working: false,
              });
            });
          }
        });
      }else{
        this.setState({
          modalLicencia: true,
          working: true,
        });

        Api.fetch("app/getLicenseRegent", { id: e.target.id, accion_id: accion_id }, "POST").then((r) => {
          this.setState({
            licencia: r,
            working: false,
          });
        });
      }
    });
  }

  handleClick_e(e) {
    Api.fetch("app/existeReposicionLicenciaEstablecimiento", { id: e.target.id}, "POST").then((r) => {
      if(r){//existe solicitud de reposicion ya aceptada
        Swal.fire({
          title: "¿Cuál licencia quieres ver?",
          showCancelButton: true,
          confirmButtonColor: "#1E90FF",
          confirmButtonText: "Original",
          showLoaderOnConfirm: true,
          reverseButtons: false,
          cancelButtonColor: "#1E90FF",
          cancelButtonText: "Reposición",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: true,
        }).then((result) => {
          if((result.isDismissed && result.dismiss === 'cancel') || result.isConfirmed){
            let reposicion = true;
            if (result.isConfirmed) {//alta o Renovación
              reposicion = false;
            }

            this.setState({
              working: true,
              modalLicencia_e: true,
              texto_reposicion: reposicion,
            });

            Api.fetch(
              "app/getLicenseEstablecimiento",
              { id: e.target.id },
              "POST"
            ).then((r) => {
              this.setState({
                licencia_e: r,
                working: false,
              });
              let licencia_id = e.target.id;
              document.querySelector("#btn-imprimir").addEventListener("click", (e) => {
                Api.fetch(
                  "app/updateClientNotificacion",
                  { id: licencia_id },
                  "POST"
                ).then((r) => {
                  this.setState({
                    licencia_e: r,
                    working: false,
                  });
                });
              });
            });
          }
        });
      }else{
        this.setState({
          working: true,
          modalLicencia_e: true,
        });
        Api.fetch(
          "app/getLicenseEstablecimiento",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setState({
            licencia_e: r,
            working: false,
          });
          let licencia_id = e.target.id;
          document.querySelector("#btn-imprimir").addEventListener("click", (e) => {
            Api.fetch(
              "app/updateClientNotificacion",
              { id: licencia_id },
              "POST"
            ).then((r) => {
              this.setState({
                licencia_e: r,
                working: false,
              });
            });
          });
        });
      }
    });
  }

  handleImprimir(lic_id, tramite_id, impresiones) {
    //resive el tramite_id
    Api.fetch(
      "app/updateImpresiones",
      { lic_id, tramite_id, impresiones },
      "PUT"
    ).then((r) => {
      if (tramite_id === "3") {
        this.setLicensesEstablecimientoPage(this.state.paginaActual_e);
      } else if (tramite_id === "1" || tramite_id === "2") {
        Api.fetch(
          "app/updateClientNotificacionRegente",
          { id: lic_id },
          "POST"
        ).then((r) => {
          this.setLicensesPage(this.state.paginaActual);
        });
      }
    });
  }

  handleImprimirNM(lic_id, impresiones) {
    //resive el tramite_id
    Api.fetch(
      "app/updateImpresionesNM",
      { lic_id, impresiones },
      "PUT"
    ).then((r) => {
      this.setLicensesEstablecimientoNMPage(this.state.paginaActual_nm);
    });
  }

  handleClick_p(e) {
    this.setState({
      working: true,
      modalLicencia_p: true,
      detalle_producto_id: e.target.id, //para notificar al imprimir
    });

    let solid = e.target.getAttribute("data-solicitud-id");

    Api.fetch("app/getSolicitudProducto?id=" + solid).then((r) => {
      this.setState({
        certificado_p: r.producto,
        certificado_s: r.solicitud,
        working: false,
      });

      if (r.solicitud.tipo_producto_veterinario_id === "1") {
        Api.fetch("app/getActivoProducto?id=" + r.producto.id).then((a) => {
          this.setState({
            activo: a.data,
          });
        });

        Api.fetch("app/getExcipienteProducto?id=" + r.producto.id).then((e) => {
          this.setState({
            excipiente: e.data,
          });
        });

        Api.fetch("app/getDosisProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            dosis: d.data,
          });
        });

        Api.fetch("app/getDescarteProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            descarte: d.data,
          });
        });
      } else if (r.solicitud.tipo_producto_veterinario_id === "2") {
        Api.fetch("app/getComposicionBiologica?id=" + r.producto.id).then(
          (d) => {
            this.setState({
              com_biologica: d.data,
            });
          }
        );

        Api.fetch("app/getComposicionQuimica?id=" + r.producto.id).then((d) => {
          this.setState({
            com_quimica: d.data,
          });
        });

        Api.fetch("app/getDosisProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            dosis: d.data,
          });
        });

        Api.fetch("app/getDescarteProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            descarte: d.data,
          });
        });
      } else if (r.solicitud.tipo_producto_veterinario_id === "3") {
        Api.fetch("app/getActivoProducto?id=" + r.producto.id).then((a) => {
          this.setState({
            activo: a.data,
          });
        });

        Api.fetch("app/getExcipienteProducto?id=" + r.producto.id).then((e) => {
          this.setState({
            excipiente: e.data,
          });
        });

        Api.fetch("app/getDosisProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            dosis: d.data,
          });
        });
      } else if (r.solicitud.tipo_producto_veterinario_id === "4") {
        Api.fetch("app/getComponente?id=" + r.producto.id).then((d) => {
          this.setState({
            componente: d.data,
          });
        });

        Api.fetch("app/getEspecieInteres?id=" + r.producto.id).then((d) => {
          this.setState({
            especie: d.data,
          });
        });
      } else if (r.solicitud.tipo_producto_veterinario_id === "5") {
        Api.fetch("app/getIngredienteAnimal?id=" + r.producto.id).then((d) => {
          this.setState({
            ingrediente: d.data,
          });
        });

        Api.fetch("app/getAnalisisAlimento?id=" + r.producto.id).then((d) => {
          this.setState({
            analisis: d.data,
          });
        });

        Api.fetch("app/getDosisProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            dosis: d.data,
          });
        });

        Api.fetch("app/getDescarteProducto?id=" + r.producto.id).then((d) => {
          this.setState({
            descarte: d.data,
          });
        });
      }

      /*  Api.fetch(
        "app/updateImpresionesConstancias",
        { id: id, impresiones: impresiones },
        "PUT"
      ).then((r) => {
        this.setConstanciasPage(this.state.paginaActual_c);
      }); */

      /*      
      
      this.setState({
        certificado_p: r.producto,
        certificado_s: r.solicitud,
        //working: false,
      });

      //let licencia_id = e.target.id;

/*
      document.querySelector("#btn-imprimir").addEventListener("click",e=>{
        Api.fetch("app/updateClientNotificacion", { id: licencia_id }, "POST").then((r) => {
          this.setState({
            certificado_p: r,
            working: false,
          });
        });
      });
*/
    });
  }

  handleClick_c(e) {
    let id = e.target.id;
    let impresiones = e.target.getAttribute("impresiones");

    this.setState({
      previa: true,
      previa_url: Api.url + `app/constancia/?id=${e.target.id}`,
    });

    //si dio imprimir es onafterprint, si buscamos para despues es .onbeforeprint
    Api.fetch(
      "app/updateImpresionesConstancias",
      { id: id, impresiones: impresiones },
      "PUT"
    ).then((r) => {
      this.setConstanciasPage(this.state.paginaActual_c);
    });
  }

  handleClick_nm(e) {
    let notable_id = e.target.getAttribute('data-notable_id');
    
    let certificado = this.state.licencias_nm.find(
      (d) => d.notable_id.toString() === notable_id
    );
    this.setState({
      modalCertificadoNM: true,
      working: false,
      certificado_nm: certificado,
    });
  }

  imprimir(elem) {
    /** Start cross browser print frame */
    //const disposePrintFrame = usePrintFrame(document.getElementById(elem))
    /** Stop using print frame */
    //disposePrintFrame();
    /*
    const iframe = document.frames
    ? document.frames[id]
    : document.getElementById(id);
  const iframeWindow = iframe.contentWindow || iframe;

  iframe.focus();
  iframeWindow.print();

  return false;
     */
  }

  handleClick_r(e) {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/refrenda/?id=${e.target.id}`,
    });
  }

  handleClick_pre(e) {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/precertificado/?id=${e.target.id}`,
    });
  }

  handleClick_ce(e) {
    this.setState({
      modalCasoEspecial: true,
      working: true,
    });
    Api.fetch("app/getCasoEspecial/?id=" + e.target.id).then((ce) => {
      this.setState({
        caso_especial: ce,
        working: false,
      });
    });
  }

  handleNotifyRegente(e) {
    //Donde e.target.id es id de la licencia
    Swal.fire({
      title: "¿Seguro que desea notificar esta licencia?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",

      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/NotificacionRegente", { id: e.target.id }, "POST").then(
          (r) => {
            this.setLicensesPage(this.state.paginaActual);
            Api.loading(false);
            //Solo para este caso de notificación
            //Api.notify(r.message);
            Swal.fire({
              title: "Notificado con éxito",
              icon: "success",
              text: r.message,
            });
          }
        );
      }
    });
  }

  handleClick_cer(e) {
    let solid = e.target.getAttribute("data-solicitud-id");

    //this.setState({certificado_id:e.target.id});
    Api.loading(true);
    Api.fetch(
      "app/getInfoCertificado",
      { certificado_id: e.target.id, solicitud_id: solid },
      "POST"
    ).then((e) => {
      e.certificado.fecha_registro = e.certificado.fecha_registro.split("-")
      .reverse()
      .join("-")
      .replaceAll("-", "/");

      e.certificado.vigencia_registro = e.certificado.vigencia_registro.split("-")
      .reverse()
      .join("-")
      .replaceAll("-", "/");

      this.setState({
        certificado: e.certificado,
        certificado_id: e.certificado.id,
        solicitud_cer: e.solicitud,
        working: false,
        modalLicencia_cer: true,
      });

      //this.handleEstBtn();

      Api.loading(false);
    });
  }

  handleNotifyEstablecimiento(e) {
    //Donde e.target.id es id de la licencia
    Swal.fire({
      title: "¿Seguro que desea notificar esta licencia?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",

      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/NotificacionEstablecimiento",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setLicensesEstablecimientoPage(this.state.paginaActual_e);
          Api.loading(false);
          //Solo para este caso de notificación
          //Api.notify(r.message);
          Swal.fire({
            title: "Notificado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  handleNotifyProducto(e) {
    //Donde e.target.id es id del detalle_solicitud_producto
    Swal.fire({
      title: "¿Seguro que desea notificar este certificado?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/NotificacionProducto", { id: e.target.id }, "POST").then(
          (r) => {
            this.setLicensesProductoPage(this.state.paginaActual_p);
            Api.loading(false);
            //Solo para este caso de notificación
            //Api.notify(r.message);
            Swal.fire({
              title: "Notificado con éxito",
              icon: "success",
              text: r.message,
            });
          }
        );
      }
    });
  }

  handleNotifyRefrenda(e) {
    //Donde e.target.id es id de certificado_refrenda
    Swal.fire({
      title: "¿Seguro que desea notificar este certificado?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch("app/NotificacionRefrenda", { id: e.target.id }, "POST").then(
          (r) => {
            this.setLicensesProductoPage(this.state.paginaActual_p);
            Api.loading(false);
            //Solo para este caso de notificación
            //Api.notify(r.message);
            Swal.fire({
              title: "Notificado con éxito",
              icon: "success",
              text: r.message,
            });
          }
        );
      }
    });
  }

  handleNotifyConstancia(e) {
    //Donde e.target.id es id de la cosntancia
    Swal.fire({
      title: "¿Seguro que desea notificar esta constancia?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/NotificacionConstancia",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setConstanciasPage(this.state.paginaActual_c);
          Api.loading(false);
          //Solo para este caso de notificación
          //Api.notify(r.message);
          Swal.fire({
            title: "Notificado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  handleNotifyPre(e) {
    //Donde e.target.id es id de la cosntancia
    Swal.fire({
      title: "¿Seguro que desea notificar el precertificado?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,      
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/NotificacionPrecertificado",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setPrecertificadosPage(this.state.paginaActual_pre);
          Api.loading(false);
          //Solo para este caso de notificación
          //Api.notify(r.message);
          Swal.fire({
            title: "Notificado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  handleNotifyEstablecimientoNM(e){
    //id establecimiento_anotacion_marginal
    Swal.fire({
      title: "¿Seguro que desea notificar al establecimiento?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/NotificacionCertificadoNM",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setLicensesEstablecimientoNMPage(this.state.paginaActual_nm);
          Api.loading(false);
          Swal.fire({
            title: "Notificado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }
  handleImprimirProducto($id) {
    Api.fetch("app/updateClientNotificacionProducto", { id: $id }, "POST").then(
      (r) => {
        this.setLicensesProductoPage(this.state.paginaActual_p);
      }
    );
  }

  handleImprimirCertificado($id) {
    Api.fetch(
      "app/updateClientNotificacionCertificado",
      { id: this.state.certificado_id },
      "POST"
    ).then((r) => {
      this.setCertificadoPage(this.state.paginaActual_cer);
    });
  }

  handleNotifyCertificado(e) {
    //CAMBIAR A CERTIFICADO
    //Donde e.target.id es id del certificado
    Swal.fire({
      title: "¿Seguro que desea notificar esta constancia?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/NotificacionCertificado",
          { id: e.target.id },
          "POST"
        ).then((r) => {
          this.setConstanciasPage(this.state.paginaActual_cer);
          Api.loading(false);
          //Solo para este caso de notificación
          //Api.notify(r.message);
          Swal.fire({
            title: "Notificado con éxito",
            icon: "success",
            text: r.message,
          });
        });
      }
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "1" })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  REGENTES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "2" })}
                onClick={() => {
                  this.toggleTab("2");
                }}
              >
                <span className="d-sm-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "3" })}
                onClick={() => {
                  this.toggleTab("3");
                }}
              >
                <span className="d-sm-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "4" })}
                onClick={() => {
                  this.toggleTab("4");
                }}
              >
                <span className="d-sm-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CONSTANCIAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_c}
                  </span>
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "5" })}
                onClick={() => {
                  this.toggleTab("5");
                }}
              >
                <span className="d-sm-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_cer}
                  </span>
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "6",
                })}
                onClick={() => {
                  this.toggleTab("6");
                }}
              >
                <span className="d-sm-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRECERTIFICADOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pre}
                  </span>
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "7",
                })}
                onClick={() => {
                  this.toggleTab("7");
                }}
              >
                <span className="d-sm-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "8" })}
                onClick={() => {
                  this.toggleTab("8");
                }}
              >
                <span className="d-sm-none">
                  ANOTACIONES MARGINALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_nm}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  ANOTACIONES MARGINALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_nm}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <fieldset>
                <div id="busqueda_r"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Activar/ Desactivar</th>
                      <th className="text-center">Observación</th>
                      <th className="text-center">PO Activa/Desactiva</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center">Fecha vencimiento</th>
                      <th className="text-center">Tipo</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.licencias.length > 0 ? (
                      this.state.licencias.map((lic) => (
                        <tr key={lic.id}>
                          <td className="text-center">{lic.folio}</td>
                          <td className="text-center">{lic.tramite}</td>
                          <td className="text-center">{lic.nombre_regente}</td>
                          <td className="text-center">{lic.estatus}</td>
                          <td className="text-center">
                            <button
                              onClick={() =>
                                this.handleChangeStatus(
                                  lic.estatus_licencia_id,
                                  lic.id
                                )
                              }
                              id={lic.id}
                              className={
                                lic.estatus_licencia_id == 1 ||
                                lic.estatus_licencia_id == 5
                                  ? `btn btn-${
                                      lic.estatus_licencia_id == 1 &&
                                      lic.fecha_emision < lic.fecha_vencimiento
                                        ? "primary"
                                        : "secondary"
                                    }`
                                  : "hide"
                              }
                            >
                              <i
                                className={`fa fa-${
                                  lic.estatus_licencia_id == 1 &&
                                  lic.fecha_emision < lic.fecha_vencimiento
                                    ? "unlock"
                                    : "lock"
                                }`}
                              ></i>
                            </button>
                          </td>
                          <td className="text-center">{lic.observacion}</td>
                          <td className="text-center">{lic.usuario}</td>
                          <td className="text-center">
                            {format(new Date(lic.fecha_emision), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">
                            {format(
                              new Date(lic.fecha_vencimiento),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{lic.tipo}</td>
                          <td className="text-justify">
                              <button
                                title="Imprimir"
                                onClick={this.handleClick}
                                id={lic.id}
                                data-accion-id={lic.accion_id}
                                className="btn btn-info"
                              >
                                <i
                                  title="Imprimir"
                                  className="fa fa-print"
                                  id={lic.id}
                                  data-accion-id={lic.accion_id}
                                ></i>
                              </button>
                          </td>
                          <td>
                            {lic.estatus === "Activa" ? (
                              <button
                                title="Notificar"
                                onClick={this.handleNotifyRegente}
                                id={lic.id}
                                className="btn  bg-gradient-yellow"
                              >
                                <i
                                  title="Notificar"
                                  className="fa fa-bell"
                                  id={lic.id}
                                ></i>
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setLicensesPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setLicensesPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleLicensePage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <fieldset>
                <div id="busqueda_e"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Razón Social</th>
                      <th className="text-center">Tipo Establecimiento</th>
                      <th className="text-center">Actividad</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center">Fecha vencimiento</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Activar / Desactivar</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.licencias_e.length > 0 ? (
                      this.state.licencias_e.map((lic) => (
                        <tr key={lic.id}>
                          <td className="text-center">{lic.folio}</td>
                          <td className="text-center">{lic.nombre}</td>
                          <td className="text-center">{lic.tramite}</td>
                          <td className="text-center">{lic.actividad}</td>
                          <td className="text-center">
                            {format(new Date(lic.fecha_emision), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">
                            {format(
                              new Date(lic.fecha_vencimiento),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{lic.estatus}</td>
                          <td className="text-center">
                            <button
                              onClick={() =>
                                this.handleChangeStatusEst(
                                  lic.estatus_licencia_id,
                                  lic.id
                                )
                              }
                              id={lic.id}
                              className={
                                lic.estatus_licencia_id == 1 ||
                                lic.estatus_licencia_id == 5
                                  ? `btn btn-${
                                      lic.estatus_licencia_id == 1 &&
                                      lic.fecha_emision < lic.fecha_vencimiento
                                        ? "primary"
                                        : "secondary"
                                    }`
                                  : "hide"
                              }
                            >
                              <i
                                className={`fa fa-${
                                  lic.estatus_licencia_id == 1 &&
                                  lic.fecha_emision < lic.fecha_vencimiento
                                    ? "unlock"
                                    : "lock"
                                }`}
                              ></i>
                            </button>
                          </td>
                          <div>
                            <td className="text-center">
                              <button
                                title="Imprimir"
                                onClick={this.handleClick_e}
                                id={lic.id}
                                className="btn btn-info"
                              >
                                <i
                                  title="Imprimir"
                                  className="fa fa-print"
                                  id={lic.id}
                                ></i>
                              </button>
                            </td>
                            {lic.estatus === "Activa" ? (
                              <td className="text-center">
                                <button
                                  title="Notificar"
                                  onClick={this.handleNotifyEstablecimiento}
                                  id={lic.id}
                                  className="btn  bg-gradient-yellow"
                                >
                                  <i
                                    title="Notificar"
                                    className="fa fa-bell"
                                    id={lic.id}
                                  ></i>
                                </button>
                              </td>
                            ) : (
                              <td></td>
                            )}
                          </div>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesEstablecimientoPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_e - 1 > 0) {
                            this.setLicensesEstablecimientoPage(
                              this.state.paginaActual_e - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_e} de {this.state.paginas_e}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_e >=
                            this.state.paginaActual_e + 1
                          ) {
                            this.setLicensesEstablecimientoPage(
                              this.state.paginaActual_e + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesEstablecimientoPage(this.state.paginas_e);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleLicenciaEstablecimiento}
                      type="number"
                      min="1"
                      max={this.state.paginas_e}
                      value={this.state.paginaActual_e}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="3">
              <fieldset>
                <div id="busqueda_p"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">No. Registro</th>
                      <th className="text-center">Trámite</th>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center">Vigencia de registro</th>
                      <th className="text-center">Tipo</th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Activar/ Desactivar</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.licencias_p.length > 0 ? (
                      this.state.licencias_p.map((lic) => (
                        <tr key={lic.id}>
                          <td title={lic.no_registro} className="text-center">
                            {String(lic.no_registro).slice(0, 100)}
                          </td>
                          <td className="text-center">{lic.tramite}</td>
                          <td
                            title={lic.nombre_comercial}
                            className="text-center"
                          >
                            {String(lic.nombre_comercial).slice(0, 200)}
                          </td>
                          <td className="text-center">
                            {format(new Date(lic.fecha_emision), "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">
                            {format(
                              new Date(lic.producto_vigencia),
                              "dd/MM/yyyy"
                            )}
                          </td>
                          <td className="text-center">{lic.tipo}</td>
                          <td className="text-center">
                            {lic.estatus_producto}
                          </td>
                          <td className="text-center">
                            <button
                              onClick={() =>
                                this.handleChangeStatusPro(
                                  lic.estatus_producto_id,
                                  lic.producto_id
                                )
                              }
                              id={lic.id}
                              className={
                                lic.estatus_producto_id != 4 &&
                                lic.estatus_producto_id != 5 &&
                                lic.tramite_id != 11
                                  ? `btn btn-${
                                      lic.estatus_producto_id == 1 ||
                                      (lic.estatus_producto_id == 3 &&
                                        lic.producto_emision <
                                          lic.producto_vigencia)
                                        ? "primary"
                                        : "secondary"
                                    }`
                                  : "hide"
                              }
                            >
                              <i
                                className={`fa fa-${
                                  (lic.estatus_producto_id == 1 ||
                                    lic.estatus_producto_id == 3) &&
                                  lic.producto_emision < lic.producto_vigencia
                                    ? "unlock"
                                    : "lock"
                                }`}
                              ></i>
                            </button>
                          </td>
                          <div>
                            {lic.tramite_id !== "11" ? (
                              <div>
                                <td className="text-center">
                                  <button
                                    title="Imprimir"
                                    onClick={this.handleClick_p}
                                    id={lic.detalle_solicitud_id}
                                    data-solicitud-id={lic.solicitud_id}
                                    className="btn btn-info"
                                  >
                                    <i
                                      title="Imprimir"
                                      className="fa fa-print"
                                      id={lic.detalle_solicitud_id}
                                      data-solicitud-id={lic.solicitud_id}
                                    ></i>
                                  </button>
                                </td>
                                <td className={lic.estatus_producto_id == 2 || lic.estatus_producto_id === "5"? "hide": "text-center"}>
                                  <button
                                    title="Notificar"
                                    onClick={this.handleNotifyProducto}
                                    id={lic.detalle_solicitud_id}
                                    data-solicitud-id={lic.solicitud_id}
                                    className="btn  bg-gradient-yellow"
                                  >
                                    <i
                                      title="Notificar"
                                      className="fa fa-bell"
                                      id={lic.detalle_solicitud_id}
                                      data-solicitud-id={lic.solicitud_id}
                                    ></i>
                                  </button>
                                </td>
                              </div>
                            ) : (
                              <div>
                                <td className="text-center">
                                  <button
                                    title="Imprimir"
                                    onClick={this.handleClick_r}
                                    id={lic.refrenda_id}
                                    className="btn btn-info"
                                    width="60"
                                  >
                                    <i
                                      title="Imprimir"
                                      className="fa fa-print"
                                      id={lic.refrenda_id}
                                    ></i>
                                  </button>
                                </td>
                                <td className={lic.estatus_producto_id == 2? "hide": "text-center"}>
                                  <button
                                    title="Notificar"
                                    onClick={this.handleNotifyRefrenda}
                                    id={lic.refrenda_id}
                                    className="btn  bg-gradient-yellow"
                                  >
                                    <i
                                      title="Notificar"
                                      className="fa fa-bell"
                                      id={lic.refrenda_id}
                                    ></i>
                                  </button>
                                </td>
                              </div>
                            )}
                          </div>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesProductoPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_p - 1 > 0) {
                            this.setLicensesProductoPage(
                              this.state.paginaActual_p - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_p} de {this.state.paginas_p}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_p >=
                            this.state.paginaActual_p + 1
                          ) {
                            this.setLicensesProductoPage(
                              this.state.paginaActual_p + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesProductoPage(this.state.paginas_p);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleLicenciaProducto}
                      type="number"
                      min="1"
                      max={this.state.paginas_p}
                      value={this.state.paginaActual_p}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="4">
              <fieldset>
                <div id="busqueda_c"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Tipo de constancia</th>
                      <th className="text-center">Validez</th>
                      <th className="text-center">Fecha emisión</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.constancias.length > 0 ? (
                      this.state.constancias.map((cons) => (
                        <tr key={cons.id}>
                          <td className="text-center">{cons.folio}</td>
                          <td className="text-center">
                            {cons.tipo_constancia}
                          </td>
                          <td className="text-center">{cons.validez}</td>
                          <td className="text-center">
                            { cons.fecha !== null?
                              cons.fecha.split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                                : ""}
                          </td>

                          {/* <td className="text-center">
                          <button
                            title="Imprimir"
                            onClick={this.handleClick_c}
                            id={cons.id}
                            data-file={
                              Api.url + `app/constancia/?id=${cons.id}`
                            }
                            className="btn btn-info"
                            width="60"
                            src={
                              Api.url +
                              `app/constancia/?id=${cons.id}`
                            }
                          >
                            <i title="Imprimir" className="fa fa-print" id={cons.id}></i>
                          </button>
                          </td>*/}
                          <td className="text-center">
                            <button
                              title="Imprimir"
                              onClick={this.handleClick_c}
                              id={cons.id}
                              impresiones={cons.impresiones}
                              className="btn btn-info"
                              width="60"
                            >
                              <i
                                title="Imprimir"
                                className="fa fa-print"
                                id={cons.id}
                                impresiones={cons.impresiones}
                              ></i>
                            </button>
                          </td>
                          <td>
                            <button
                              title="Notificar"
                              onClick={this.handleNotifyConstancia}
                              id={cons.id}
                              className="btn  bg-gradient-yellow"
                            >
                              <i
                                title="Notificar"
                                className="fa fa-bell"
                                id={cons.id}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td>No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_c - 1 > 0) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_c} de {this.state.paginas_c}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_c >=
                            this.state.paginaActual_c + 1
                          ) {
                            this.setConstanciasPage(
                              this.state.paginaActual_c + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setConstanciasPage(this.state.paginas_c);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleConstanciasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_c}
                      value={this.state.paginaActual_c}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>

            <TabPane tabId="5">
              <fieldset>
                <div id="busqueda_certificado"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio certificado</th>
                      <th className="text-center">Tipo de certificado</th>
                      <th className="text-center">Nombre comercial</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center">Fecha vencimiento</th>
                      <th className="text-center">Estado</th>
                      {/*<th className="text-center">Activar/  Desactivar</th>*/}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.certificados.length > 0 ? (
                      this.state.certificados.map((lic) => (
                        <tr key={lic.id}>
                          <td
                            title={lic.folio_certificado}
                            className="text-center"
                          >
                            {String(lic.folio_certificado).slice(0, 100)}
                          </td>
                          <td className="text-center">
                            {lic.tipo_certificado}
                          </td>
                          {/*            <td className="text-center">{lic.tramite}</td> */}
                          <td
                            title={lic.nombre_comercial}
                            className="text-center"
                          >
                            {String(lic.nombre_comercial).slice(0, 200)}
                          </td>
                          <td className="text-center">{lic.fecha_emision}</td>
                          {
                            <td className="text-center">
                              {lic.fecha_vencimiento}
                            </td>
                          }

                          <td className="text-center">
                            {lic.estatus_certificado}
                          </td>
                          {/*<td className="text-center">
                         
                         <button
                           onClick={() =>
                             this.handleImprimirCertificado(lic.certificado_id,lic.solicitud_id)
                           }
                           id={lic.id} 
                           className={(lic.status === 1)?(`btn btn-${
                             lic.fecha_emision < lic.fecha_vencimiento
                               ? "primary"
                               : "secondary"
                           }`): "hide"}
                         >
                           <i
                             className={`fa fa-${
                               (lic.status === 1 ) &&
                               lic.fecha_emision < lic.fecha_vencimiento
                                 ? "unlock"
                                 : "lock"
                             }`}
                           ></i>
                         </button>
                            </td>*/}
                          <div>
                            <div>
                              <td className="text-center">
                                <button
                                  title="Imprimir"
                                  onClick={this.handleClick_cer}
                                  id={lic.certificado_id}
                                  data-solicitud-id={lic.solicitud_id}
                                  className="btn btn-info"
                                >
                                  <i
                                    title="Imprimir"
                                    className="fa fa-print"
                                    id={lic.certificado_id}
                                    data-solicitud-id={lic.solicitud_id}
                                  ></i>
                                </button>
                              </td>
                              <td>
                                <button
                                  title="Notificar"
                                  onClick={this.handleNotifyCertificado}
                                  id={lic.certificado_id}
                                  data-solicitud-id={lic.solicitud_id}
                                  className="btn  bg-gradient-yellow"
                                >
                                  <i
                                    title="Notificar"
                                    className="fa fa-bell"
                                    id={lic.certificado_id}
                                    data-solicitud-id={lic.solicitud_id}
                                  ></i>
                                </button>
                              </td>
                            </div>
                          </div>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadoPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_cer - 1 > 0) {
                            this.setCertificadoPage(
                              this.state.paginaActual_cer - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_cer} de{" "}
                          {this.state.paginas_cer}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_cer >=
                            this.state.paginaActual_cer + 1
                          ) {
                            this.setCertificadoPage(
                              this.state.paginaActual_cer + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCertificadoPage(this.state.paginas_cer);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleCertificadoPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_cer}
                      value={this.state.paginaActual_cer}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>

            <TabPane tabId="6">
              <fieldset>
                <div id="f_busqueda_pre"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio precertificado</th>
                      <th className="text-center">No. Factura</th>
                      <th className="text-center">Tipo de precertificado</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center">Fecha vencimiento</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.precertificados.length > 0 ? (
                      this.state.precertificados.map((lic) => (
                        <tr key={lic.id}>
                          <td title={lic.folio} className="text-center">
                            {String(lic.folio).slice(0, 100)}
                          </td>
                          <td className="text-center">{lic.num_factura}</td>
                          <td className="text-center">
                            {lic.tipo_precertificado}
                          </td>
                          {/*            <td className="text-center">{lic.tramite}</td> */}
                          <td className="text-center">{lic.fecha_emision}</td>
                          {
                            <td className="text-center">
                              {lic.fecha_vencimiento}
                            </td>
                          }

                          <td className="text-center">
                            <button
                              title="Imprimir"
                              onClick={this.handleClick_pre}
                              id={lic.id}
                              className="btn btn-info"
                              width="60"
                            >
                              <i
                                title="Imprimir"
                                className="fa fa-print"
                                id={lic.id}
                              ></i>
                            </button>
                          </td>
                          <td>
                            <button
                              title="Notificar"
                              onClick={this.handleNotifyPre}
                              id={lic.id}
                              className="btn  bg-gradient-yellow"
                            >
                              <i
                                title="Notificar"
                                className="fa fa-bell"
                                id={lic.id}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPrecertificadoPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_pre - 1 > 0) {
                            this.setPrecertificadoPage(
                              this.state.paginaActual_pre - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_pre} de{" "}
                          {this.state.paginas_pre}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_pre >=
                            this.state.paginaActual_pre + 1
                          ) {
                            this.setPrecertificadoPage(
                              this.state.paginaActual_pre + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setPrecertificadoPage(this.state.paginas_pre);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handlePreCertificadosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_pre}
                      value={this.state.paginaActual_pre}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>

            <TabPane tabId="7">
              <fieldset>
                <div id="buscadorCE"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Tipo importación</th>
                      <th className="text-center">
                        Establecimiento importador
                      </th>
                      <th className="text-center">
                        Establecimiento fabricante
                      </th>
                      <th className="text-center">Fecha emisión</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGridCE ? "hide" : ""}>
                    {this.state.casos_especiales.length > 0 ? (
                      this.state.casos_especiales.map((ce, index) => (
                        <tr key={index}>
                          <td title={ce.folio} className="text-center">
                            {ce.folio}
                          </td>
                          <td className="text-center">
                            {ce.tipo_importacion_nombre}
                          </td>
                          <td className="text-center">
                            {ce.importador_razon_social}
                          </td>
                          {/*            <td className="text-center">{lic.tramite}</td> */}
                          <td className="text-center">
                            {ce.fabricante_razon_social}
                          </td>
                          {<td className="text-center">{ce.fecha_emision}</td>}

                          <td className="text-center">
                            <button
                              title="Imprimir"
                              onClick={this.handleClick_ce}
                              id={ce.id}
                              className="btn btn-info"
                              width="60"
                            >
                              <i
                                title="Imprimir"
                                className="fa fa-print"
                                id={ce.id}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGridCE ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_ce - 1 > 0) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_ce} de{" "}
                          {this.state.paginas_ce}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_ce >=
                            this.state.paginaActual_ce + 1
                          ) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(this.state.paginas_ce);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setCasosEspecialesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_ce}
                      value={this.state.paginaActual_ce}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>

            <TabPane tabId="8">
              <fieldset>
                <div id="buscadorNM"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Razón Social</th>
                      <th className="text-center">Anotación Marginal</th>
                      <th className="text-center">Fecha emisión</th>
                      <th className="text-center"></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.licencias_nm.length > 0 ? (
                      this.state.licencias_nm.map((lic) => (
                        <tr key={lic.id}>
                          <td className="text-center">{lic.folio_solicitud}</td>
                          <td className="text-center">{lic.razon_social}</td>
                          <td className="text-center">{lic.anotacion_marginal}</td>
                          <td className="text-center">
                          { lic.fecha_aprueba_asesoria !== null?
                              lic.fecha_aprueba_sinaip.split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/")
                                : ""}
                          </td>
                          <td className="text-center">
                            <button
                              title="Imprimir"
                              onClick={this.handleClick_nm}
                              id={lic.id}
                              data-notable_id={lic.notable_id}
                              className="btn btn-info"
                            >
                              <i
                                title="Imprimir"
                                className="fa fa-print"
                                id={lic.id}
                                data-notable_id={lic.notable_id}
                              ></i>
                            </button>
                          </td>
                            <td className="text-center">
                              <button
                                title="Notificar"
                                onClick={this.handleNotifyEstablecimientoNM}
                                id={lic.id}
                                className="btn  bg-gradient-yellow"
                              >
                                <i
                                  title="Notificar"
                                  className="fa fa-bell"
                                  id={lic.id}
                                ></i>
                              </button>
                            </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesEstablecimientoNMPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_nm - 1 > 0) {
                            this.setLicensesEstablecimientoNMPage(
                              this.state.paginaActual_nm - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_nm} de {this.state.paginas_nm}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_nm >=
                            this.state.paginaActual_nm + 1
                          ) {
                            this.setLicensesEstablecimientoNMPage(
                              this.state.paginaActual_nm + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setLicensesEstablecimientoNMPage(this.state.paginas_nm);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleLicenciaEstablecimientoNM}
                      type="number"
                      min="1"
                      max={this.state.paginas_nm}
                      value={this.state.paginaActual_nm}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
              loading="eager"
              id="visualizador_pdf"
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({ previa: false });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
                {/*  <a
                  className="btn btn-yellow"
                  onClick={(e) => this.imprimir('visualizador_pdf')}
                >
                  imprimir
                </a> */}
              </div>
            </center>
          </div>
        </div>
        <Licencia
          modalLicencia={this.state.modalLicencia}
          working={this.state.working}
          licencia={this.state.licencia}
          date={this.state.date}
          reposicion={this.state.texto_reposicion}
          change={this.handleClose}
          imprimir={this.handleImprimir}
        />
        <Licencia
          modalLicencia={this.state.modalLicencia_e}
          working={this.state.working}
          licencia={this.state.licencia_e}
          date={this.state.date}
          reposicion={this.state.texto_reposicion}
          change={this.handleClose}
          imprimir={this.handleImprimir}
        />
        <Certificado
          modalLicencia={this.state.modalLicencia_p}
          working={this.state.working}
          producto={this.state.certificado_p}
          solicitud={this.state.certificado_s}
          activo={this.state.activo}
          excipientes={this.state.excipiente}
          componente={this.state.componente}
          especie={this.state.especie}
          ingrediente={this.state.ingrediente}
          analisis={this.state.analisis}
          dosis={this.state.dosis}
          descarte={this.state.descarte}
          date={this.state.date}
          com_biologica={this.state.com_biologica}
          com_quimica={this.state.com_quimica}
          id_detalleP_notificar={this.state.detalle_producto_id}
          imprimir={this.handleImprimirProducto}
          change={this.handleClose}
        />
        <CertificadoP
          modalLicencia={this.state.modalLicencia_cer}
          working={this.state.working}
          certificado={this.state.certificado}
          solicitud={this.state.solicitud_cer}
          date={this.state.date}
          /*  activo={this.state.activo}
          excipientes={this.state.excipiente}
          componente={this.state.componente}
          especie={this.state.especie}
          ingrediente={this.state.ingrediente}
          analisis={this.state.analisis}
          dosis={this.state.dosis}
          descarte={this.state.descarte}
         
          com_biologica={this.state.com_biologica}
          com_quimica={this.state.com_quimica} */
          id_detalleP_notificar={this.state.certificado_id}
          imprimir={this.handleImprimirCertificado} //modificar columna numero de impresiones
          change={this.handleClose}
        />
        <AvalCE
          modalCasoEspecial={this.state.modalCasoEspecial}
          change={this.handleCloseModalCE}
          caso_especial={this.state.caso_especial}
          working={this.state.working}
        ></AvalCE>
        <CertificadoNM
          modalLicencia={this.state.modalCertificadoNM}
          working={this.state.working}
          licencia={this.state.certificado_nm}
          date={this.state.date}
          change={this.handleClose}
          imprimir={this.handleImprimirNM}
        ></CertificadoNM>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <LicensePrint auth={auth} history={history} {...props} />;
};
